<template>
  <div class="col-xl-12 col-md-12">
    <b-card bg-variant="info" text-variant="white" class="text-center">
      <b-card-text v-if="!loadStatus">{{ $t("addwizard.request_status") }} : {{ this.status.statusNameAr }}
      </b-card-text>
      <b-spinner v-else type="grow" label="Loading..." class="loading" />
      <div v-if="this.status.statusCode == 'OL'">
        <hr />

        <b-button variant="relief-warning" @click="letterOffer">{{ $t("addwizard.accepted_letter") }}
        </b-button>
      </div>
    </b-card>
    <div class="card user-card-full">
      <div class="row m-l-0 m-r-0" v-if="!loadForm">
        <div class="col-sm-6">
          <div class="card-block">
            <h6 class="m-b-20 p-b-5 b-b-default f-w-600">
              {{ $t("addwizard.course_selection") }}
            </h6>
            <div class="row">
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.intake") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.IntakeCode }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.first_choice") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ getCourse(item.FirstCourseSelection) }}
                </h6>
              </div>
              <div class="col-sm-6" v-if="item.FirstCourseLanguageOfStudy">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.language_of_study") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.FirstCourseLanguageOfStudy }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.second_choice") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ getCourse(item.SecondCourseSelection) }}
                </h6>
              </div>
              <div class="col-sm-6" v-if="item.SecondCourseLanguageOfStudy">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.language_of_study") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.SecondCourseLanguageOfStudy }}
                </h6>
              </div>
            </div>
          </div>
          <div class="card-block">
            <h6 class="m-b-20 p-b-5 b-b-default f-w-600">
              {{ $t("addwizard.education_background") }}
            </h6>
            <div class="row">
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.academicLevel") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ geteducation(item.EducationLevel) }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.Certificate_Name") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.CertificateName }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.institution_Name") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.InstitutionName }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.Year_of_Graduation") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.GraduationYear }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.Grade_GPA") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.CPAGrade }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.specialazation") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.Specialization }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.educationCountry") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ getcitizenship(item.Country) }}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="card-block">
            <h6 class="m-b-20 p-b-5 b-b-default f-w-600">
              {{ $t("addwizard.personal_details") }}
            </h6>
            <div class="row">
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.fullname") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.FullName }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.ArabicName") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.FullNameAr }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.BirthDate") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.DOB }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.gender") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.gender }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.Race") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.Race }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.Religion") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.Religion }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.Citizenship") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ getcitizenship(item.Citizenship) }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.ID_Card") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.IDPassportNo }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.IDPassportIssuedCountry") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ getcitizenship(item.IDPassportIssuedCountry) }}
                </h6>
              </div>
            </div>
          </div>
          <div class="card-block">
            <h6 class="m-b-20 p-b-5 b-b-default f-w-600">
              {{ $t("addwizard.contact_details") }}
            </h6>
            <div class="row">
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">{{ $t("addwizard.email") }}</p>
                <h6 class="text-muted f-w-400">
                  {{ item.email }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.phone_no_home") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.PhoneHome }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.phone_no_mobile") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.PhoneMCountryCode }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.whatsapp") }}
                </p>
                <h6 class="text-muted f-w-400">
                  <span v-if="item.MobileHasWhatsApp == 0">
                    {{ $t("addwizard.no") }}</span>
                  <span v-else> {{ $t("addwizard.yes") }}</span>
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.ResidentialCountry") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.PostalAddressCountry }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.cityApplicant") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.PostalAddressCity }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.streetApplicant") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.PostalAddressStreet }}
                </h6>
              </div>
              <div class="col-sm-6">
                <p class="m-b-10 f-w-600">
                  {{ $t("addwizard.post_codeApplicant") }}
                </p>
                <h6 class="text-muted f-w-400">
                  {{ item.PostCode }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-spinner v-else type="grow" label="Loading..." class="loading" />
    </div>
    <div class="card user-card-full">
      <div class="card-body" v-if="!load">
        <validation-observer ref="dataForm">
          <b-row>
            <b-col md="3">
              <b-form-group id="input-group-title" :label="$t('addwizard.title')" label-for="input-title">
                <validation-provider #default="{ errors }" name="title" vid="title" rules="required">
                  <b-form-input id="input-title" v-model="newItem.title" type="text"
                    :placeholder="$t('addwizard.title')">
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group id="input-group-27" :label="$t('addwizard.category')" label-for="input-27">
                <validation-provider #default="{ errors }" name="category" vid="category" rules="required">
                  <b-form-select v-model="newItem.category" :placeholder="$t('addwizard.category')">
                    <option value="PHOTO">Photo of the applicant</option>
                    <option value="IDCARD">ID/Passport of the applican</option>
                    <option value="CERT">Academic Certificate</option>
                    <option value="TRANS">Academic Transcrip</option>
                    <option value="PROPOS">
                      Area of Proposed Research (for Master / PHD – By research)
                    </option>
                    <option value="OTHER">Supporting Documents</option>
                  </b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group id="input-group-CERT" :label="$t('addwizard.file')" label-for="input-CERT">
                <b-form-file v-model="newItem.file" accept="application/pdf,image/*"
                  :placeholder="$t('addwizard.file')" />
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-button block :disabled="invalid" variant="primary" @click="submit()">
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button>
            </b-col>
          </b-row>
        </validation-observer>
        <b-container fluid class="p-1 bg-dark">
          <b-row>
            <b-col v-for="file in files" :key="file.id">
              <template v-if="isImage(file.file_path)">
                <b-img thumbnail fluid :src="file.file_path" style="height: 150px" />
              </template>

              <template v-else-if="isPDF(file.file_path)">
                <div @click="openFile(file.file_path)" style="cursor: pointer;">
                  <b-img thumbnail fluid src="/dashboard/img/pdf_icon.png" style="height: auto" />

                </div>
                
              </template>
            </b-col>

          </b-row>
        </b-container>
      </div>
      <b-spinner v-else type="grow" label="Loading..." class="loading" />
    </div>
  </div>
</template>

<script>
import UsersController from "@/Controllers/UsersController";
import MediuEduController from "@/Controllers/MediuEduController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import EduProgramsController from '@/Controllers/EduProgramsController';
import Auth from "@/Apis/Auth";

export default {
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      newItem: {},
      item: {},
      course: [],
      educationLevel: [],
      citizenship: [],
      religion: [],
      race: [],
      files: [],
      load: false,
      loadForm: false,
      loadStatus: false,
      status: "",
      userRefNumber: null
    };
  },
  async created() {
    this.loadForm = true;
    this.loadStatus = true;
    this.load = true;
    this.item = await new UsersController().OnlineApplication(
      this.$route.params.id
    );
    this.userRefNumber = this.item.reference_no;

    // this.newItem.referenceNo = this.item.reference_no;
    this.newItem.referenceNo = this.userRefNumber;
    const ct = new MediuEduController();
    this.course = await ct.GetCourse();
    this.educationLevel = await ct.GetEducationLevel();
    this.citizenship = await ct.GetCitizenship();
    this.religion = await ct.GetReligion();
    this.race = await ct.GetRace();
    this.loadForm = false;
    this.status = await new UsersController().admissionstatus({
      referenceNo: this.item.reference_no,
    });

    const info = await new UsersController().enrollmentInfo({
      referenceNo: this.item.reference_no,
    });

    if (this.status.statusCode == "EN") {
      const info = await new UsersController().enrollmentInfo({
        referenceNo: this.item.reference_no,
      });
      if (info.matricNo) {
        const subscribe = await new EduProgramsController().SubscribebyCode(
          info
        );
        if (subscribe.eduProgram) {
          localStorage.setItem("eduProgram", subscribe.eduProgram.id);
          this.$router.push("/");
        }
      }
    }

    this.loadStatus = false;
    this.files = await new UsersController().getFile(this.item.reference_no);
    this.load = false;
  },
  methods: {
    async goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.load = true;
      let res = await new UsersController().sendFile(this.newItem, "FormData");
      if (res.status) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "تمت العملية بنجاح",
          showConfirmButton: false,
          timer: 3000,
        });
        this.files = await new UsersController().getFile(
          this.item.reference_no
        );

        this.load = false;
        return true;
      } else {
        Swal.fire({
          position: "top-start",
          icon: "error",
          title: "هناك خطأ",
          text: res.message,
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
    },
    async letterOffer() {
      let res = await new UsersController().letterOffer(
        this.newItem,
        "FormData"
      );
      if (res.status) {
        Swal.fire({
          // position: "top-end",
          icon: "success",
          title: "تمت العملية بنجاح",
          showConfirmButton: false,
          timer: 3000,
        });
        // this.files = await new UsersController().getFile("ADM19CI664");

        this.load = false;
        return true;
      } else {
        console.log(res);
        Swal.fire({
          // position: "top-start",
          icon: "error",
          title: "هناك خطأ",
          text: res.errors.error,
          showConfirmButton: false,
          timer: 6000,
        });
        return false;
      }
    },
    getCourse(code) {
      const course = this.course.find((c) => c.CourseCode == code);
      return course.NameAr;
    },

    geteducation(code) {
      const course = this.educationLevel.find((c) => c.Code_ == code);
      return course.Level;
    },
    getcitizenship(code) {
      const course = this.citizenship.find((c) => c.Code == code);
      if (!code) return "";
      return course.NameAr;
    },
    isImage(path) {
      return /\.(jpeg|jpg|gif|png|webp)$/i.test(path);
    },
    isPDF(path) {
      return /\.pdf$/i.test(path);
    },
    openFile(path) {

      window.open(path, "_blank");
    },
  },
};
</script>

<style>
.user-card-full .user-profile {
  border-radius: 5px 0 0 5px;
}

.bg-c-lite-green {
  background: -webkit-gradient(linear,
      left top,
      right top,
      from(#f29263),
      to(#ee5a6f));
  background: linear-gradient(to right, #ee5a6f, #f29263);
}

.user-profile {
  padding: 20px 0;
}

.card-block {
  padding: 1.25rem;
}

.m-b-25 {
  margin-bottom: 25px;
}

.img-radius {
  border-radius: 5px;
}

h6 {
  font-size: 14px;
}

.card .card-block p {
  line-height: 25px;
}

@media only screen and (min-width: 1400px) {
  p {
    font-size: 14px;
  }
}

.card-block {
  padding: 1.25rem;
}

.b-b-default {
  border-bottom: 1px solid #e0e0e0;
}

.m-b-20 {
  margin-bottom: 20px;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.card .card-block p {
  line-height: 25px;
}

.m-b-10 {
  margin-bottom: 10px;
}

.text-muted {
  color: #919aa3 !important;
}

.b-b-default {
  border-bottom: 1px solid #e0e0e0;
}

.f-w-600 {
  font-weight: 600;
}

.m-b-20 {
  margin-bottom: 20px;
}

.m-t-40 {
  margin-top: 20px;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-t-40 {
  margin-top: 20px;
}

.user-card-full .social-link li {
  display: inline-block;
}

.user-card-full .social-link li a {
  font-size: 20px;
  margin: 0 10px 0 0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>